import { defineStore, storeToRefs } from "pinia";
import { computed } from "vue";
import { useSurveyTargetsStore } from "@stores/survey/surveyTargets";

export const useTargetListStore = defineStore("targetList", () => {
  const surveyTargetsStore = useSurveyTargetsStore();
  const { currentTargets } = storeToRefs(surveyTargetsStore);

  // FIXME: this is function has to be in its own store surveyTargetsStore
  const targetOptions = computed(() => {
    const options = currentTargets.value.map((target) => ({ label: target.name, value: target.id }));
    return [{ label: "All targets", value: 0 }].concat(options);
  });

  return {
    currentTargets,
    targetOptions,
  };
});
